import { exp } from 'mathjs'
import fly, { genFormData } from './fly'
// 预订模块
// 获取员工宿舍房型
export const roomTypeListApi = (params: any) => fly.get('/ajax/Reserve/roomTypeList.json', params)
// 获取招待所房型
export const reservePreRoomApi = (params: any) => fly.get('/ajax/Reserve/PreRoom.json', params)
// 获取楼栋
export const buildingNoListApi = (params: any) => fly.get('/ajax/Reserve/BuildingNoList.json', params)
// 获取层级
export const StructureList = (params: any) => fly.get('/ajax/Reserve/StructureList.json', params)
// // 获取楼层
// export const floorNoListApi = (params: any) => fly.get('/ajax/Reserve/FloorNoList.json', params)
// 获取房间
export const sanyRoomApi = (params: any) => fly.get('/ajax/Reserve/Room.json', params)
// 获取床位号
export const sanyBedListApi = (params: any) => fly.get('/ajax/Reserve/BedList.json', params)
// 获取员工信息及部门
export const employeeInfoApi = (params: any) => fly.get('/ajax/Reserve/EmployeeInfo.json', params)
// 提交预订
export const bookRoomAddApi = (params: any) => fly.post('/ajax/Reserve/Add.json', genFormData(params))
// 获取门店
export const ReserveStoreListApi = (params: any) => fly.get('/ajax/Reserve/StoreList.json', (params))
// 获取城市
export const StoreCityListApi = (params: any) => fly.get('/ajax/Reserve/StoreCityList.json.json', (params))

// 换房模块
// 换房详情
export const changeRoomApi = (params: any) => fly.get('/ajax/Changeroom/info.json', params)
// 提交换房
export const changeroomSaveApi = (params: any) => fly.post('/ajax/Changeroom/save.json', genFormData(params))
// 取消换房
export const changeroomCancelApi = (params: any) => fly.post('/ajax/Changeroom/cancel.json', genFormData(params))

// 退房模块
// 退房详情
export const syCheckoutApi = (params: any) => fly.post('/ajax/syCheckout/detail.json', genFormData(params))
// 取消退房
export const cancelCheckooutApi = (params: any) => fly.post('/ajax/syCheckout/cancel.json', genFormData(params))
// 重新申请退房
export const applyCheckooutApi = (params: any) => fly.post('/ajax/syCheckout/apply.json', genFormData(params))

// 判断用户是否一条数据都没有
export const checkReserveApi = (params: any) => fly.get('/ajax/Dormitorymanage/check.json', params)

// 宿舍管理列表
export const manageListApi = (params: any) => fly.get('/ajax/Dormitorymanage/list.json', params)

// 宿舍管理详情
export const dormDetailApi = (params: any) => fly.get('/ajax/Dormitorymanage/detail.json', params)

// 提交签约
export const signAddApi = (params: any) => fly.post('/ajax/sign/add.json', genFormData(params))

// 合同详情
export const contractDetailApi = (params: any) => fly.get('/ajax/contract/syDetail.json', params)

// 预订详情
export const bookingDetailApi = (params: any) => fly.get('/ajax/Reserve/Detail.json', params)

// 取消预订申请
export const cancelReserveApplyApi = (params: any) => fly.get('/ajax/Reserve/Cancel.json', params)

// 账单列表
export const billListApi = (params: any) => fly.get('/ajax/CheckinBill/List.json', params)

// 账单详情及支付方式
export const billDetailApi = (params: any) => fly.get('/ajax/Pay/PayType.json', params)

// 获取支付配置信息 调起原生
// export const payInfoApi = (params: any) => fly.get('/ajax/Pay/Payment.json', params)

// 续租详情
export const reletDetailApi = (params: any) => fly.get('/ajax/bedcontinue/info.json', params)

// 提交续租
export const reletCommitApi = (params: any) => fly.post('/ajax/bedcontinue/save.json', genFormData(params))

// 取消续租
export const reletCancelApi = (params: any) => fly.post('/ajax/bedcontinue/cancel.json', genFormData(params))

// 获取员工各级部门
export const departListApi = (params: any) => fly.get('/ajax/common/Department.json', params)

// 上传图片
export const uploadImageApi = (params: any) => fly.post('/ajax/common/uploadImg.json', params)

// 获取支付宝支付配置
export const alipayApi = (params: any) => fly.get('/ajax/Pay/Alipay.json', params)

// 获取微信H5支付配置
export const wechatPayApi = (params: any) => fly.get('/ajax/Pay/Wxpay.json', params)


// 查询订单是否完成
export const billResultApi = (params: any) => fly.get('/ajax/Pay/Payquery.json', params)

// 排队 房间详情接口
export const lineupRommInfoApi = (params: any) => fly.get('/ajax/Queue/RoomTypeDetail.json', params)

// 提交排队申请
export const submitLineupApi = (params: any) => fly.get('/ajax/Queue/Add.json', params)

// 排队详情
export const lineupInfoApi = (params: any) => fly.get('/ajax/Queue/Detail.json', params)

// 排队取消
export const cancelLineupApi = (params: any) => fly.get('/ajax/Queue/Cancel.json', params)

// 排队延期
export const prolongLineupApi = (params: any) => fly.get('/ajax/Queue/Renewal.json', params)

// 发送验证码
export const sendVerifyApi = (params: any) => fly.get('/ajax/syapp/sendVerify.json', params)

// 验证码登录
export const appLoginApi = (params: any) => fly.post('/ajax/syapp/login.json', genFormData(params))

// 充值房间信息查询
export const rechargeRoomApi = (params: any) => fly.get('/ajax/Recharge/Room.json', params)

// 充值历史列表
export const rechargeHisApi = (params: any) => fly.get('/ajax/Recharge/His.json', params)

// 能源费支付
export const rechargePayApi = (params: any) => fly.get('/ajax/Recharge/Pay.json', params)
// 查询充值能源费订单是否完成
export const RechargeResultApi = (params: any) => fly.get('/ajax/Recharge/Payquery.json', params)